<template>
  <el-form-item
    :label="name"
    :prop="code"
  >
    <tinymce-editor :value="value" @input="handleChange" />
  </el-form-item>
</template>

<script>
import TinymceEditor from "@/components/editor/tinymce/TinymceEditor.vue"

export default {
  name: "FormEditorItem",
  components: {
    TinymceEditor
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    keyField: {
      type: String,
      default: ''
    },
    valueField: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      val: null,
      errorSign: false,
      message: '',
      defaultVal: ''
    }
  },
  methods: {
    /**
     * 内容修改
     * @param val
     */
    handleChange(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
